import Connectors from './Connectors/Connectors.vue';
import Dialogs from './Dialogs/Dialogs.vue';
import Entities from './Entities/Entities.vue';
import IntentsRoute from './Intents/Intents.router';
import IQTools from './IQTools.vue';
import SystemTriggers from './SystemTriggers/SystemTriggers.vue';
import Workflows from './Workflows/Workflows.vue';
import MigrateRoute from './Migrate/Migrate.router';
import Forms from './Forms/Index.vue';
import FormsManage from './Forms/Manage.vue';
import featureFlags from '@/store/modules/featureFlags';
import get from 'lodash/get';

const enableAgentForms = get(featureFlags, 'state.FEATURE_FLAGS.AGENTIC_FORMS', false);
const enableMcpConnectors = get(featureFlags, 'state.FEATURE_FLAGS.MCP_CONNECTORS', false);
const rootRoute = {
  path: '/iqtools',
  name: 'IQ Tools',
  component: IQTools,
  meta: {
    auth: true,
  },
};

export default {
  ...rootRoute,
  children: [
    IntentsRoute,
    {
      path: 'entities',
      name: 'Entities',
      component: Entities,
      meta: {
        auth: true,
        resource: rootRoute.path,
        parentName: rootRoute.name,
      },
    },
    {
      path: 'dialogs',
      name: 'Dialogs',
      component: Dialogs,
      meta: {
        auth: true,
        resource: rootRoute.path,
        parentName: rootRoute.name,
      },
      children: [
        {
          path: ':id',
          component: Dialogs,
          meta: {
            auth: true,
            resource: rootRoute.path,
            parentName: rootRoute.name,
          },
        },
      ],
    },
    {
      path: 'workflows',
      name: 'Workflows',
      component: Workflows,
      meta: {
        auth: true,
        resource: rootRoute.path,
        parentName: rootRoute.name,
      },
      children: [
        {
          path: ':id',
          component: Workflows,
          meta: {
            auth: true,
            resource: rootRoute.path,
            parentName: rootRoute.name,
          },
        },
      ],
    },
    MigrateRoute,
    {
      path: 'system-triggers',
      name: 'System Triggers',
      component: SystemTriggers,
      meta: {
        auth: true,
        parentName: rootRoute.name,
      },
    },
    ...(enableAgentForms ? [
      {
        path: 'forms',
        name: 'Forms',
        component: Forms,
        meta: {
          auth: true,
          resource: '/iqtools/forms',
          parentName: rootRoute.name,
        },
      },
      {
        path: 'forms/:id',
        name: 'ManageForms',
        component: FormsManage,
        meta: {
          auth: true,
          resource: '/iqtools/forms/:id',
          parentName: 'Forms',
        },
      },
    ] : []),
    ...(enableMcpConnectors ? [
      {
        path: 'connectors',
        name: 'Connectors',
        component: Connectors,
        meta: {
          auth: true,
          resource: '/iqtools/connectors',
          parentName: rootRoute.name,
        },
      },
    ] : []),
  ],
};
